import { useFragmentParams } from '@web/helpers/routing';

export function useTokenFragment(): string | null {
  const fragments = useFragmentParams();
  return fragments.get('token');
}
